import React from 'react';
import { observer } from 'mobx-react-lite';
import { ReactComponent as ArrowIcon } from 'components/icons/down.svg';
import { NumberStepperWrapper, StepperButtons, StepperButtonsOuter, StepperOval } from './NumberStepperStyles';

export interface IProps {
  value: number;
  valueChange: (newValue: number, changedBy: number) => void;
  valueSpanClassName?: string;
  minValue?: number;
  maxValue?: number;
  isAlwaysVisible?: boolean;
}
export const NumberStepper: React.FC<IProps> = observer((props: IProps) => {
  const { value, valueChange, valueSpanClassName, minValue, maxValue, isAlwaysVisible } = props;

  const onButtonClick = (change: number) => {
    const newValue = value + change;
    if ((minValue !== undefined && newValue < minValue) || (maxValue !== undefined && newValue > maxValue)) {
      valueChange(value, 0);
    } else {
      valueChange(newValue, change);
    }
  };
  return (
    <NumberStepperWrapper>
      <StepperButtonsOuter className={`${isAlwaysVisible ? 'always-visible' : ''}`}>
        <StepperButtons>
          <StepperOval onClick={() => onButtonClick(1)}>
            <ArrowIcon className='arrow-up' />
          </StepperOval>
          <StepperOval onClick={() => onButtonClick(-1)}>
            <ArrowIcon className='arrow-down' />
          </StepperOval>
        </StepperButtons>
      </StepperButtonsOuter>
      <span className={`${valueSpanClassName}`}>{value}</span>
    </NumberStepperWrapper>
  );
});
